import { Component } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AppService } from '@ui-components/services';
import { IProfile, IResponse } from '@interfaces/index';
import { switchMap } from 'rxjs';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrl: './account.component.scss'
})
export class AccountComponent {
  
  selected = 0;
  tabs = ['users', 'organizations', 'cohorts', 'allotments']
  profile: IProfile | null = null;

  get isSuperAdmin() {
    return this.profile?.role_id === 1;
  }

  constructor(
    protected _app_service: AppService,
    protected _router: Router,
    protected _route: ActivatedRoute
  ) {}

  ngOnInit() {
    this._app_service.getProfile().pipe(
      switchMap(
        (response: IResponse<IProfile>) => {
          this.profile = response.data;
          if (![1, 2].includes(this.profile.role_id)) {
            this.tabs.splice(1, 1);
            this.tabs.pop();
          } else if (this.profile.role_id === 2) {
            this.tabs.splice(1, 1);
          }          
          return this._route.params;
        }
      )
    ).subscribe(
      (params: Params) => {
        this.selected = this.tabs.findIndex((element: string) => {
          return element === params['type']
        });
        
        this.selected = this.selected === -1 ? 0 : this.selected;
        this.go(this.selected);
      }
    );
  }

  go(index: number ) {
    const url = this.tabs[index];
    this._router.navigate(['/manage-account', url]);
  }
}
